var map = {
	"./Advcash.svg": 9480,
	"./Bitcoin.svg": 4804,
	"./Dogecoin.svg": 2606,
	"./Litecoin.svg": 1421,
	"./Mastercard.svg": 7754,
	"./Payoneer.svg": 3261,
	"./Paypal.svg": 3339,
	"./Perfectmoney.svg": 2423,
	"./QIWI.svg": 8180,
	"./Ripple.svg": 312,
	"./Skrill.svg": 6975,
	"./Tether.svg": 7142,
	"./Visa.svg": 1229,
	"./Webmoney.svg": 2688,
	"./Yoomoney.svg": 4463,
	"./icons/arrow-btn.svg": 6661,
	"./icons/calendar.svg": 681,
	"./icons/card.svg": 3473,
	"./icons/check.svg": 7121,
	"./icons/cloud.svg": 3822,
	"./icons/copy.svg": 9384,
	"./icons/copyright.svg": 5542,
	"./icons/flag-ar.svg": 2667,
	"./icons/flag-de.svg": 8575,
	"./icons/flag-en.svg": 6155,
	"./icons/flag-es.svg": 1518,
	"./icons/flag-fr.svg": 9014,
	"./icons/flag-pt.svg": 7522,
	"./icons/flag-ru.svg": 6781,
	"./icons/flag-tr.svg": 5936,
	"./icons/flag-usa.svg": 5571,
	"./icons/how-1.svg": 5837,
	"./icons/how-2.svg": 2862,
	"./icons/how-3.svg": 9884,
	"./icons/how-4.svg": 32,
	"./icons/how-5.svg": 4417,
	"./icons/how-6.svg": 7314,
	"./icons/icq.svg": 2432,
	"./icons/info.svg": 5923,
	"./icons/mail.svg": 7686,
	"./icons/skype.svg": 9995,
	"./icons/telegram.svg": 3774,
	"./icons/tg.svg": 4248,
	"./icons/theme-1.svg": 1088,
	"./icons/theme-2.svg": 5635,
	"./icons/theme-3.svg": 2994,
	"./icons/theme-4.svg": 7661,
	"./icons/theme-5.svg": 7948,
	"./icons/theme-6.svg": 3295,
	"./icons/theme-7.svg": 8542,
	"./icons/theme-8.svg": 5273,
	"./icons/up.svg": 852,
	"./icons/user.svg": 6602,
	"./logo-costaction.svg": 3621,
	"./logo-footer.svg": 9225,
	"./logo-hitfile.svg": 4281,
	"./logo-turbobit.svg": 6877,
	"./logo.svg": 7503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;